import React from 'react'
import InvitePeople from './InvitePeople'
import ShareMemberships from './ShareMemberships'
import { WorkspacePermissions } from './ParentPermissions'
import { ShareForSettingsModal } from './types'
import PublicPermissions from './PublicPermissions'
import { ProjectPermissions } from './ProjectPermissions/ProjectPermissions'

export interface ShareSettingsProps {
  share: Pick<
    ShareForSettingsModal,
    | 'identifier'
    | 'publicUrl'
    | 'publicAccessLevel'
    | 'userCanUpdateSettings'
    | 'publicCommentsEnabled'
    | 'publicInspectEnabled'
    | 'userCanUpdateCommentsEnabled'
    | 'allowedParentAccessLevels'
    | 'type'
    | 'parentAccessLevel'
    | 'userCanUpdateParentPermissions'
    | 'isDraft'
    | 'workspace'
    | 'name'
    | 'memberships'
    | 'project'
    | 'userCanPublish'
    | 'publication'
    | 'privacyIcon'
  >
}

export const ShareSettings = ({ share }: ShareSettingsProps) => {
  const shouldShowProjectPermissions =
    Boolean(share.project) && share.project?.type === 'STANDARD'
  const shouldShowWorkspacePermssions =
    !shouldShowProjectPermissions && share.userCanUpdateParentPermissions

  return (
    <>
      <InvitePeople share={share} />
      <PublicPermissions
        share={share}
        workspaceId={share.workspace.identifier}
      />
      {shouldShowProjectPermissions ? (
        <ProjectPermissions
          share={share}
          project={share.project!}
          workspace={share.workspace}
          actions={null}
        />
      ) : null}
      {shouldShowWorkspacePermssions ? (
        <WorkspacePermissions share={share} />
      ) : null}
      <ShareMemberships share={share} />
    </>
  )
}
